"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTableOverview", {
  enumerable: true,
  get: function get() {
    return _SVBTableOverview.default;
  }
});
var _SVBTableOverview = _interopRequireDefault(require("./src/SVBTableOverview"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }